import axios from "@/api/axios";

const tagsList = (data) => {
    return axios
        .post('/admin/tags/tags-list', {tags: data})
        .then(response => response.data)
}

const tagsFullList = (data) => {
    return axios
        .post('/admin/tags/tags-full-list', {tags: data})
        .then(response => response.data)
}

const tagsAdd = (data) => {
    return axios
        .post('/admin/tags/tags-add', {tags: data})
        .then(response => response.data)
}

const tagsUpdate = (data) => {
    return axios
        .post('/admin/tags/tags-update', {tags: data})
        .then(response => response.data)
}

const tagsClientUpdate = (data) => {
    return axios
        .post('/admin/tags/tags-client-update', {tags: data})
        .then(response => response.data)
}

export default {
    tagsList,
    tagsFullList,
    tagsAdd,
    tagsUpdate,
    tagsClientUpdate
}